export const TableSkeleton = () => {
  const skeletonClassName = 'animate-pulse bg-gray-200 dark:bg-[#2A2B2B]';
  const greenSkeletonClassName = 'animate-pulse bg-green-200 dark:bg-green-900';

  return (
    <div className="rounded-xl rounded-bl-none rounded-br-none overflow-hidden border dark:border-dark-borderMid p-4">
      <table className="min-w-full">
        <tbody>
          {Array.from({length: 10}).map((_, index) => (
            <tr
              key={index}
              className="w-full flex hover:bg-gray-100 dark:hover:bg-gray-900 transition-background transition-colors transition-opacity ease-in-out duration-500
          "
            >
              <td className="w-full m-1">
                <div
                  className={`${skeletonClassName} rounded w-5 w-full h-10`}
                ></div>
              </td>

              <td className="w-full m-1">
                <div
                  className={`${skeletonClassName} rounded w-5 w-full h-10`}
                ></div>
              </td>

              <td className="w-full m-1">
                <div
                  className={`${greenSkeletonClassName} rounded w-5 w-full h-10`}
                ></div>
              </td>

              <td className="w-full m-1">
                <div
                  className={`${skeletonClassName} rounded w-5 w-full h-10`}
                ></div>
              </td>

              <td className="w-full m-1">
                <div
                  className={`${skeletonClassName} rounded w-5 w-full h-10`}
                ></div>
              </td>
              <td className="w-full m-1">
                <div
                  className={`${skeletonClassName} rounded w-5 w-full h-10`}
                ></div>
              </td>
              <td className="w-full m-1">
                <div
                  className={`${skeletonClassName} rounded w-5 w-full h-10`}
                ></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
